import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo-icon">
                <img 
                  src="https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/vut25uz5_CSS%20LOGO%20PNG.png" 
                  alt="CSS Caribbean Meal Logo" 
                  className="company-logo-footer"
                />
              </div>
              <div>
                <h3>CSS Caribbean Meal</h3>
                <p>Great Tasting Food Every Time!</p>
              </div>
            </div>
            <p className="footer-description">
              Family-owned food manufacturing facility specializing in authentic Caribbean-style frozen dinners.
            </p>
          </div>

          <div className="footer-section">
            <h4>Contact Information</h4>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin size={18} />
                <span>Newnan, Georgia, USA</span>
              </div>
              <div className="contact-item">
                <Phone size={18} />
                <span>(678) 876-9392</span>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <span>Carlene.SmithMartin@cssmeal.com</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#products">Our Products</a></li>
              <li><a href="#story">Our Story</a></li>
              <li><a href="#footer">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Quality Assurance</h4>
            <div className="certifications">
              <div className="cert-badge">USDA Certified</div>
              <div className="cert-badge">Food Safety Standards</div>
            </div>
            <p className="cert-description">
              All products produced under strict USDA Food Safety guidelines.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 CSS Caribbean Meal. All rights reserved.</p>
          <p>Established September 2023 | First Production March 13, 2024</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
